import type { AdminNamespace } from '@cli-types/next-adapter/config.js'
import { DEFAULT_ADMIN_NAMESPACE } from '@cli-constants/scaffolding.js'
import { toCamelCase, toPascalCase, toScreamingSnake } from '@cli-utils/text.js'
import { validateAdminNamespace } from './validate-admin-namespace.js'

export function resolveAdminNamespace(value = DEFAULT_ADMIN_NAMESPACE): AdminNamespace {
  const segment = validateAdminNamespace(value)
  const pascal = toPascalCase(segment)

  return {
    segment,
    alias: `@${segment}`,
    camel: toCamelCase(segment),
    pascal,
    screaming: toScreamingSnake(segment),
    routePath: `/${segment}`,
    apiPath: `/api/${segment}`,
    cssRootClass: `${segment}-root`,
    globalsFile: `${segment}-globals.css`,
    routeGroup: `(${segment})`
  }
}
